import styled from "styled-components"
import { rgba } from "../../../config/variable"

const CallStatsStyle = styled.div`
  .callstats {
    display: flex;
    width: 100%;
    border-radius: 10px;
    flex-direction: column;
    &__header {
      display: flex;
      justify-content: space-between;
      width: 100%;
      margin-bottom: 16px;
      .ant-typography {
        margin: 0;
        font-size: 16px;
        font-weight: 500;
      }
    }
    &__queue-stats {
      padding: 31px 24px;
      margin-top: 9px;
      box-shadow: 0px 0 10px 0
        ${(props) => rgba(props.theme.colortileblack, 0.05)};
      background-color: ${(props) => props.theme.bgcolordwhiteblack};
      border: 1px solid ${(props) => props.theme.colorbluegreylight};
      border-radius: 16px;
      .head {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        margin-bottom: 31px;
        .ant-typography {
          margin: 0;
          font-size: 16px;
          font-weight: 500;
        }
      }
      .q-warapper {
        display: flex;
        justify: space-between;
        gap: 24px;
        flex-wrap: wrap;
        .list {
          padding: 16px;
          border: 1px solid ${(props) => props.theme.colorbluegreylight};
          border-radius: 12px;
          flex: 0 0 calc(50% - 16px);
          display: flex;
          align-items: center;
          justify-content: space-between;
          &__left {
            font-size: 16px;
            font-weight: 500;
            color: ${(props) => props.theme.colorlightblack};
            display: flex;
            align-items: center;
            gap: 12px;
            .anticon {
              color: ${(props) => props.theme.textcolordarkgrey};
            }
          }
          &__right {
            font-size: 20px;
            color: ${(props) => props.theme.colorlightblack};
          }
        }
        .q-block {
          flex: 1;
          border: 1px solid ${(props) => props.theme.colorbluegreylight};
          border-radius: 16px;
          padding: 24px;
          position: relative;
          overflow: hidden;

          &.time {
            .q-block__header {
              .icon-wrapper {
                background: rgba(24, 80, 141, 0.1);
              }
            }
          }
          &.average-time {
            .q-block__header {
              .icon-wrapper {
                background: rgba(41, 111, 0, 0.1);
              }
            }
          }
          span.bg-icon {
            position: absolute;
            right: 0;
            bottom: -10px;
          }
          .time {
            margin-top: 33px;
            margin-bottom: 0;
          }
          &__header {
            display: flex;
            align-items: center;
            gap: 10px;
            .ant-typography {
              margin-bottom: 0;
            }

            .icon-wrapper {
              width: 56px;
              height: 56px;
              border-radius: 6px;
              display: flex;
              align-items: center;
              justify-content: center;
              background: rgba(217, 129, 3, 0.1);
            }
          }
        }
      }
    }
    .call-q-wrapper {
      margin-top: 9px;
      background-color: ${(props) => props.theme.bgcolordwhiteblack};
      display: flex;
      justify: space-between;
      gap: 24px;
      .q-block {
        flex: 1;
        border: 1px solid ${(props) => props.theme.colorbluegreylight};
        box-shadow: 0px 0 10px 0
          ${(props) => rgba(props.theme.colortileblack, 0.05)};
        border-radius: 16px;
        padding: 24px;
        .list {
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-bottom: 1px solid ${(props) => props.theme.colorbluegreylight};
          padding: 13px 0;
          &__left {
            display: flex;
            align-items: center;
            gap: 14px;
            .square {
              width: 18px;
              height: 18px;
              border-radius: 2px;
              background: blue;
            }
            .text {
              font-size: 12px;
              font-weight: 400;
              color: ${(props) => props.theme.colorlightblack};
            }
            .icon {
              font-size: 17px;
              color: ${(props) => props.theme.colorlightgrey};
            }
          }
          &__right {
            font-size: 16px;
            font-weight: 500;
            color: ${(props) => props.theme.colorlightblack};
          }
        }
        &__header {
          display: flex;
          justify-content: space-between;
          width: 100%;
          margin-bottom: 16px;
          .ant-typography {
            margin: 0;
            font-size: 16px;
            font-weight: 500;
          }
        }
      }
    }
  }
`
export default CallStatsStyle